import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgxPaginationModule } from "ngx-pagination";
import { EditarComponent } from "./editar/editar.component";
import { PesquisaComponent } from './pesquisa/pesquisa.component';
import { QuestaoAppComponent } from "./questao.app.component";
import { QuestaoRoutingModule } from "./questao.route";
import { QuestaoService } from "./services/questao.service";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { jqxWindowModule } from "jqwidgets-ng/jqxwindow";
import { jqxListBoxComponent, jqxListBoxModule } from "jqwidgets-ng/jqxlistbox";

@NgModule({
    declarations:[
        QuestaoAppComponent,
        EditarComponent,
        PesquisaComponent
    ],
    imports:[
        NgbModule,
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        QuestaoRoutingModule,
        jqxWindowModule,
        jqxListBoxModule
    ],
    providers:[QuestaoService]
})
export class QuestaoModule{}